import { Controller } from "@hotwired/stimulus"
import WOW from 'wow.js'

export default class extends Controller {
  connect() {
    // ANCHOR ANIMATIONS
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 800);
          return false;
        }
      }

    });

    // WOW ANIMATIONS INITIALIZE
    new WOW().init();

    // NAVBAR CLICK
    $(".navbar-nav li a").click(function(){
      $('#navbar').removeClass('in');
    })
  }
}
